// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"109":"eb51d4ef","174":"8a8185a2","605":"301c5a6d","672":"34324b61","725":"a0c7b269","741":"779b266f"}[chunkId] + ".js";
};